<template>
  <div class="canvas_container">
    <!-- <button class="btn" @click="playVideo">播放</button> -->
    <van-image v-if="!isVideo" class="banner_img" :lazy-load="lazyLoad" :src="src" :width="width" :height="height">
      <!-- <template v-slot:loading>
        <van-image class="banner_img" :src="require('../assets/img/canvas_default.png')" :width="width" :height="height" />
      </template> -->
      <template v-slot:error>
        <van-image class="banner_img" :src="require('../assets/img/canvas_default.png')" :width="width" :height="height" />
      </template>
    </van-image>
    <video v-if="isVideo && isAndroid" ref="video" :style="{width:(width)+'px',height:'100%'}" id="video" :src="src" x5-video-player-type="h5-page" :x5-video-player-fullscreen="true" loop muted preload="auto" poster="../assets/img/canvas_default.png"></video>
    <!-- <video-player v-if="isVideo && isAndroid && isLoad" :playsinline="true" class="video-player vjs-custom-skin" ref="videoPlayer" :options="playerOptions" controls="controls" x5-video-player-type="h5" x5-video-player-fullscreen="true" loop muted></video-player> -->
    <!-- <video v-if="isVideo && isAndroid" :width="width" :height="height?height:'100%'" webkit-playsinline playsinline x5-playsinline x5-video-player-type="h5"  x5-video-player-fullscreen="true" class="video" ref="video" :src="src" :style="{width:width?width+'px':'100%',height:height?height+'px':'100%'}" muted loop></video> -->
    <video-player v-if="isVideo && isIos" v-show="false" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions" @play="onPlayerPlay($event)"></video-player>
    <canvas v-if="isVideo && isIos" ref="myCanvas" :width="width" :height="height?height:'100%'"></canvas>
    <img v-if="isVideo && isIos" id="poster" v-show="false" src="../assets/img/canvas_default.png" alt="">
  </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player';
export default {
  name: "canvas-bg",
  data() {
    return {
      isIos: false,
      isLoad: false,
      playerOptions: {
        //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, // 如果true,浏览器准备好时开始播放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        flash: {
          swf: '/video-js.swf'
        },
        sources: [
          {
            type: 'video/mp4',
            src: '', // 你的视频地址（必填） https://live-playtimeshift.tfgreenroad.com/3db89c34vodcq1255717697/4d1f9c8f5285890805716632186/AetxFr5m3eAA.mp4
          },
        ],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth,
        height: 1000,
        notSupportedMessage: '', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false, // 全屏按钮
        },
      },
      ctx: '',
      isAndroid: false,
      interval: null
    };
  },
  components: {
    videoPlayer,
  },
  props: {
    //   路径
    src: {
      default: () => { return "" },
      type: String
    },
    // 懒加载是否开启(只支持图片)
    lazyLoad: {
      default: () => { return false },
      type: Boolean
    },
    // 宽度
    width: {
      default: () => { return document.body.clientWidth },
      type: Number
    },
    // 高度
    height: {
      default: () => { return 0 },
      type: Number
    },
    // 是否是视频
    isVideo: {
      default: () => { return true },
      type: Boolean
    },
  },
  mounted() {
    this.initbackground();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {

    initbackground() {
      let u = navigator.userAgent;
      this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      this.isAndroid = !this.isIos;

      if (this.isVideo && this.isAndroid) {
        this.clickHandle = () => {
          if (window.WeixinJSBridge) {
            WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
              if (this.$route.name == 'HomePage' || this.$route.name == 'bindingPhone') {
                document.getElementById('video').play();
              } else {
                // document.removeEventListener('click',this.clickHandle);
              }
            })
          } else {
            document.addEventListener("WeixinJSBridgeReady", () => {
              WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                if (this.$route.name == 'HomePage' || this.$route.name == 'bindingPhone') {
                  document.getElementById('video').play();
                } else {
                  // document.removeEventListener('click',this.clickHandle);
                }
              })
            }, false);
          }
        }
        document.addEventListener('click', this.clickHandle);
      }

      this.$nextTick(() => {
        if (this.isVideo) {
          if (!this.isIos) {   // android处理方案
            let v = document.getElementById('video');
            v.style.width = this.width + "px";
            v.style.height = this.height + "px";
            if (window.WeixinJSBridge) {
              WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                v.play();
              })
            } else {
              document.addEventListener("WeixinJSBridgeReady", () => {
                WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                  v.play();
                })
              }, false);
            }
          } else {  // ios处理方案，不再更改 (微信内置浏览器安卓不支持canvas绘制video)
            this.playerOptions.sources[0].src = this.src;
            this.playerOptions.height = this.height;
            let ctx = this.$refs.myCanvas.getContext('2d');
            this.ctx = ctx;
            let poster = document.getElementById('poster');
            setTimeout(() => {
              ctx.drawImage(poster, 0, 0, document.body.clientWidth, this.height);
            }, 500);
            this.$nextTick(() => {
              setTimeout(() => {
                if (window.WeixinJSBridge) {
                  WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                    this.$refs.videoPlayer.player.play();
                  })
                } else {
                  document.addEventListener("WeixinJSBridgeReady", () => {
                    WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                      this.$refs.videoPlayer.player.play();
                    })
                  }, false);
                }
              }, 500)
            })
          }
        } else {
          //console.log('进行图片处理');
        }
      })
    },
    onPlayerPlay() {
      this.$nextTick(() => {
        let ctx = this.ctx;
        let v = $('.video-player video')[0];
        let videoWidth = document.body.clientWidth;
        let videoHeight = this.height;
        setTimeout(() => {
          clearInterval(this.interval);
          this.interval = setInterval(() => {
            ctx.drawImage(v, 0, 0, videoWidth, videoHeight);
          }, 15);
        }, 500)
      })
    },
    playVideo() {
      //console.log('触发视频播放');
      let v = this.$refs.video;
      v.play();
      //console.log(v, '安卓video标签');
    }
  },
};
</script>
<style lang="scss" scoped>
.canvas_container {
  overflow: hidden;
  .banner_img {
    width: 100%;
    height: 100%;
  }
  #video {
    position: absolute;
    z-index: 1;
    margin: 0;
    padding: 0;
    object-fit: fill;
  }
  .btn {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1111;
  }
}
</style>